module.exports = __webpack_public_path__ + "static/mansion-30ea291832c2dd73e640163fc4a069aa.jpg";